import { 
    COMMUNICATION_QUIZ_SUCCESS,
    COMMUNICATION_QUIZ_BEGIN,
    COMMUNICATION_QUIZ_FAILURE,
	COMMUNICATION_QUIZ_CLEAR,

	RESPONSABLE_QUIZ_BEGIN,
	RESPONSABLE_QUIZ_SUCCESS,
	RESPONSABLE_QUIZ_FAILURE,
	RESPONSABLE_QUIZ_CLEAR,
} from 'app/actions/CommunicationQuizActions';

const initialState = {
	quiz: {},
	responsableQuiz: {},
	isLoading: false,
};

export default function CommunicationQuizReducer (state = initialState, action) {
	switch (action.type) {
        case COMMUNICATION_QUIZ_BEGIN: 
			return {
				...state,
				isLoading: true
			}
		case COMMUNICATION_QUIZ_SUCCESS: 
			let quiz = action.payload.data;
			return {
				...state,
				quiz,
				isLoading: false,
			};
        case COMMUNICATION_QUIZ_FAILURE: 
			return {
				...state,
				isLoading: false
            }
        case COMMUNICATION_QUIZ_CLEAR:
            return {
                ...state,
                quiz: [],
                isLoading: false
            }
        case RESPONSABLE_QUIZ_BEGIN: 
			return {
				...state,
				isLoading: true
			}
		case RESPONSABLE_QUIZ_SUCCESS: 
			let responsableQuiz = action.payload.data;
			return {
				...state,
				responsableQuiz,
				isLoading: false,
			};
        case RESPONSABLE_QUIZ_FAILURE: 
			return {
				...state,
				isLoading: false
            }
        case RESPONSABLE_QUIZ_CLEAR:
            return {
                ...state,
                responsableQuiz: {},
                isLoading: false
            }
		default:
			return state;
	}
};

//COMMUNICATION QUIZ
export const getCommunicationQuiz = state => {
	return state.quiz;
}
export const getIsLoadingCommunicationQuiz = state => {
    return state.isLoading;
}

//RESPONSABLE QUIZ
export const getResponsableQuiz = state => {
	return state.responsableQuiz;
}
export const getIsLoadingResponsableQuiz = state => {
    return state.isLoading;
}